import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import App from './App';

const getClientSideId = (env: string | undefined) => {
  if (env === 'production' || env === 'preprod' || env === 'internal-prod') {
    return '6053a56c427dc00dba3527fb';
  }
  if (env === 'verify') {
    return '6053a5c17100be0dfd0739ee';
  }
  return '6053a56c427dc00dba3527fa';
};

(async () => {
  let LDProvider: any;
  try {
    LDProvider = await asyncWithLDProvider({
      clientSideID: getClientSideId(import.meta.env.MODE),
      flags: {}, // Add flags (that are used) here, read more: https://docs.launchdarkly.com/sdk/client-side/react/react-web#configuring-the-react-sdk
    });
  } catch (err) {
    console.log(err);
    Sentry.withScope((scope) => {
      scope.setFingerprint(['launchDarklyInitialization', String(err.message)]);
      Sentry.captureException(err);
    });
  }

  const AppComponent = React.createElement(App);

  /** ***************************************************************************************************************************
    Wrapping App with LDProvider conditionally will make all the flags "undefined" if LDProvider fails to initialize properly.
    It is important NOT to rely on the default value of the flags in the app especially when their type is not boolean. We must
    treat them as non-existent when their switch is off even though they might have a value.
  ***************************************************************************************************************************** */

  const AppComponentWithLDProvider = LDProvider
    ? React.createElement(LDProvider, null, AppComponent)
    : AppComponent;

  ReactDOM.render(AppComponentWithLDProvider, document.getElementById('root'));
})();
